import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQ = ({ items }) => (
  <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
    {items.map((f, i) => (
      <AccordionItem key={i} value={`faq-${i}`} className="border-slate-200">
        <AccordionTrigger
          className="text-left font-heading text-sm font-semibold text-navy-900 hover:text-emerald-600 sm:text-base"
          data-testid={`faq-question-${i}`}
        >
          {f.question}
        </AccordionTrigger>
        <AccordionContent className="text-sm leading-relaxed text-slate-600" data-testid={`faq-answer-${i}`}>
          {f.answer}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
